import ClassChannelRoute from "./ClassChannel";
import CustomChannelRoute from "./CustomChannel";
import FamilyChannelRoute from "./FamilyChannel";

const ChannelViewRoutes = [
  ClassChannelRoute,
  CustomChannelRoute,
  FamilyChannelRoute,
];

export default ChannelViewRoutes;
